import React from 'react'
import {config, useSpring} from 'react-spring'
import Layout from '../components/layout'
import {AnimatedBox} from '../elements'

const Paddle = () => {
  const pageAnimation = useSpring({
    config: config.slow,
    from: {opacity: 0},
    to: {opacity: 1},
  })

  return (
    <Layout>
      <AnimatedBox
        style={pageAnimation}
        py={[6, 6, 6, 8]}
        px={[6, 6, 8, 6, 8, 13]}
      >
        <h1>Hi!</h1>
        <p>
          You can visit{' '}
          <a href="https://paddle.com/blog/a-cat-named-kino/">
            {' '}
            Paddle website
          </a>{' '}
          for more information.
        </p>
      </AnimatedBox>
    </Layout>
  )
}

export default Paddle
